module.exports = __webpack_public_path__ + "static/usdaLoanbg-13a8f4ab673daac807cbddb15fb9b7cc.jpg";